import { PageRoutes } from "../constants/routes";
import EditProfile from "../pages/EditProfile/EditProfile";
import GamePlay from "../pages/GamePlay/GamePlay";
import Homepage from "../pages/Homepage/Homepage";
import Leaderboard from "../pages/Leaderboard/Leaderboard";
import { Settings } from "../pages/Settings";
import { Languages } from "../pages/Languages";
import { Faq } from "../pages/Faq";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";
import { TermAndCondition } from "../pages/TermsAndCondition";
import Shop from "../pages/Shop/Shop";
import Profile from "../pages/Profile/Profile";
import LeaderboardActivity from "../pages/LeaderboardActivity/LeaderboardActivity";
import { Onboarding } from "../pages/Onboarding";
import { useParams } from "react-router-dom";
import Guest from "../pages/Guest/Guest";

type IRoute = {
  path: string;
  element: React.ReactNode;
};

function PlayPageWrapper() {
  const { gameId } = useParams();
  return <GamePlay key={gameId} />;
}

const ROUTES: IRoute[] = [
  {
    path: PageRoutes.Home,
    element: <Homepage />,
  },
  {
    path: PageRoutes.Leaderboard,
    element: <Leaderboard />,
  },
  {
    path: PageRoutes.Settings,
    element: <Settings />,
  },
  {
    path: PageRoutes.Language,
    element: <Languages />,
  },
  {
    path: PageRoutes.Faq,
    element: <Faq />,
  },
  {
    path: PageRoutes.PrivacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: PageRoutes.TermAndCondition,
    element: <TermAndCondition />,
  },
  {
    path: PageRoutes.Shop,
    element: <Shop />,
  },
  {
    path: PageRoutes.Me,
    element: <Profile />,
  },
  {
    path: PageRoutes.EditProfile,
    element: <EditProfile />,
  },
  {
    path: `${PageRoutes.Play}/:gameId`,
    element: <PlayPageWrapper />,
  },
  {
    path: `${PageRoutes.LeaderboardActivity}/:leaderboardId`,
    element: <LeaderboardActivity />,
  },
  {
    path: PageRoutes.Onboarding,
    element: <Onboarding />,
  },
  {
    path: PageRoutes.Guest,
    element: <Guest />,
  },
];

export const routes = ROUTES.map(({ path, element }, idx) => ({
  path,
  element: element,
  id: `route-${path}-${idx}`,
}));
